/**
 * Wakelocks
 * Currently only Chromium-based browsers are supported.
 * https://developer.mozilla.org/en-US/docs/Web/API/Screen_Wake_Lock_API
 */

let wakelockElement = null;
let setUpWakelock = () => {};
let releaseWakelock = () => {};
let wakeLockActive = false;

if ("wakeLock" in navigator) {
    setUpWakelock = () => {
        try {
            if(wakeLockActive){
                console.log('wakeLock already active');
                return;
            }
            navigator.wakeLock.request("screen").then((wl) => {
                wakelockElement = wl;
                wakeLockActive = true;
            }).catch((err)=>{
                //retry
                setTimeout(()=>{
                    setUpWakelock();
                },2000);
            });
            console.log("Wakelock Service: wakelock acquired.");
        } catch (error) {
            wakeLockActive = false;
            console.error(`Wakelock Service: Cannot acquire wakelock: ${error.message}`);
        }
    };

    releaseWakelock = () => {
        wakeLockActive = false;
        wakelockElement &&
        wakelockElement.release().then(() => {
            wakelockElement = null;
            console.log("Wakelock Service: wakelock released.");
        });
    };
} else {
    console.warn("Wakelock Service: Wakelocks are not supported in this browser. Sorry.");
}

export { setUpWakelock, releaseWakelock };
